import React, { useEffect, useState, useContext } from 'react';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import {SortableContainer, SortableElement} from 'react-sortable-hoc';
import arrayMove from 'array-move';
import ListItem from './listItem';
import {LocalizationContext} from '../../contexts';
import './index.scss';

const SortableItem = SortableElement(({data, settings, onRemove, onToggel, itemTitle, itemContent}) => <ListItem data={data} settings={settings} onRemove={onRemove} onToggel={onToggel} itemTitle={itemTitle} itemContent={itemContent} />);
const SortableList = SortableContainer(({items, settings, onRemove, onToggel, itemTitle, itemContent}) => {
    return (
      <div className="listEditor-listContainer">
        {items.map((value, index) => (
          <SortableItem key={`item-${index}`} index={index} data={value} settings={{...settings, index: index, isOpen: settings.openItemIndex === index}} onRemove={onRemove} onToggel={onToggel} itemTitle={itemTitle} itemContent={itemContent} />
        ))}
      </div>
    );
  });

export default function ListEditor({list, emptyItem = {}, isSortable = true, canAdd = true, canRemove = true, minSize = 0, maxSize = false, itemTitle = false, title = false, onListUpdate = false, itemContent = false, addNewItemBtnText = false, startElement = false, className = '', removeContentOnClose = true}) {
    const [localization] = useContext(LocalizationContext);
    const [data, _setData] = useState([]);
    const [removeItemIndex, setRemoveItemIndex] = useState(false);
    const [openItemIndex, setOpenItemIndex] = useState(false);

    useEffect(() => {
        if(list && list.length) {
            _setData([...list]);
        }
        else {
            _setData([]);
        }
    }, [list]);

    const setData = (data) => {
        if(onListUpdate) {
            onListUpdate(data);
        }
        else {
            _setData(data);
        }
    };
    const onSortEnd = ({oldIndex, newIndex, ...a}) => {
        setData(arrayMove(data, oldIndex, newIndex));
    };
    const addNewItemStart = () => {
        setData([JSON.parse(JSON.stringify(emptyItem)), ...data]);
        setOpenItemIndex(0);
    };
    const addNewItemEnd = () => {
        setData([...data, JSON.parse(JSON.stringify(emptyItem))]);
        setOpenItemIndex(data.length);
    };
    const setRemoveItem = (index) => {
        if(index === false || (index >= 0 && index < data.length)) {
            setRemoveItemIndex(index);
        }
    };
    const removeItem = () => {
        if(removeItemIndex !== false && removeItemIndex >= 0 && removeItemIndex < data.length)  {
            let newData = [...data];
            newData.splice(removeItemIndex, 1);
            setData(newData);
            if(removeItemIndex === openItemIndex) {
                openItem(false);
            }
        }
        setRemoveItem(false);
    }
    const openItem = (index) => {
        if(index === false || (index >= 0 && index < data.length)) {
            setOpenItemIndex(index === openItemIndex ? false : index);
        }
    };

    const settings = {
        isSortable, 
        canRemove, 
        minSize, 
        maxSize, 
        listLength: data.length, 
        openItemIndex,
        removeContentOnClose
    };

    return <div className={"listEditor" + (className ? " " + className : "")}>
        {title && <div className="listEditor-title">{typeof(title) === "function" ? title(settings) : title}</div>}
        {startElement && <div className="listEditor-startElement">{startElement}</div>}
        <div className="listEditor-addPanel">
            {canAdd && (maxSize === false || data.length < maxSize) && 
                <button onClick={addNewItemStart} className="listEditor-addBtn k-button">
                    {addNewItemBtnText || localization.labels.list_editor.add_new_item_btn}
                    <span className='k-icon k-i-plus'/>
                </button>
            }
        </div>
        {data && data.length > 0 && <SortableList 
            items={data} 
            updateBeforeSortStart={() => {openItem(false)}}
            onSortEnd={onSortEnd} 
            helperClass={"listEditor-listDraggingItem"} 
            useDragHandle={true} 
            settings={settings} 
            onRemove={setRemoveItem}
            onToggel={openItem}
            itemTitle={itemTitle}
            itemContent={itemContent}
        />}
        <div className="listEditor-addPanel">
            {canAdd && data.length > 0 && (maxSize === false || data.length < maxSize) && 
                <button onClick={addNewItemEnd} className="listEditor-addBtn k-button">
                    {addNewItemBtnText || localization.labels.list_editor.add_new_item_btn}
                    <span className='k-icon k-i-plus'/>
                </button>
            }
        </div>
        {removeItemIndex !== false && <Dialog onClose={() => { setRemoveItem(false); }} title={false}>
            <p>{localization.labels.list_editor.item_remove_text}</p>
            <DialogActionsBar>
                <button className="k-button k-primary" onClick={removeItem}>{localization.labels.list_editor.item_remove_yes_btn}</button>
                <button className="k-button" onClick={() => {setRemoveItem(false)}}>{localization.labels.list_editor.item_remove_no_btn}</button>
            </DialogActionsBar>
        </Dialog>}
    </div>;
};